import { Container } from "react-bootstrap";
import React, { ReactElement } from "react";
// eslint-disable-next-line import/extensions
import animationData from "../../../../../lotties/data-website.json";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
import Platinum from "../platinumPackage/index.tsx";
import { Accordion } from "react-bootstrap";


export default function Faqs (): ReactElement
{
  const { t } = useTranslation();
  const faqData = [
    {
      question: t( "sme_faq_question_1" ),
      answer: t( "sme_faq_answer_1" )
    },
    {
      question: t( "sme_faq_question_2" ),
      answer: t( "sme_faq_answer_2" )
    },
    {
      question: t( "sme_faq_question_3" ),
      answer: t( "sme_faq_answer_3" )
    },
    {
      question: t( "sme_faq_question_4" ),
      answer: t( "sme_faq_answer_4" )
    },
    {
      question: t( "sme_faq_question_5" ),
      answer: t( "sme_faq_answer_5" )
    },
    {
      question: t( "sme_faq_question_6" ),
      answer: t( "sme_faq_answer_6" )
    },
    {
      question: t( "sme_faq_question_7" ),
      answer: t( "sme_faq_answer_7" )
    },
    {
      question: t( "sme_faq_question_8" ),
      answer: t( "sme_faq_answer_8" )
    }
  ];
  return (
    <div className="landing-page-wrapper faq-pa">
      <section className="my-health-takaful-bnr pb-5">
        <Container className="text-center">
          <h1 className="mhtb-title">
            { t( "auto_frequently_asked" ) } <span className="text-primary">{ t( "auto_question" ) }</span>
          </h1>

          {/* Use mapping to dynamically create the accordion */ }
          <Accordion
            defaultActiveKey="0"
            className="w-100 sehatZamin-accordion"
            id="basicAccordion"
          >
            { faqData.map( ( faq, index ) => (
              <Accordion.Item
                eventKey={ index.toString() }
                key={ index }
              >
                <Accordion.Header className="candb-title">{ faq.question }</Accordion.Header>
                <Accordion.Body className="text-start">
                  <strong className="fw-normal candb-caption">{ faq.answer }</strong>
                </Accordion.Body>
              </Accordion.Item>
            ) ) }
          </Accordion>
        </Container>
      </section>
    </div>
  );
}
